export const c_tabs_link_accent_start = {
  "name": "--pf-v6-c-tabs--link-accent--start",
  "value": "0",
  "var": "var(--pf-v6-c-tabs--link-accent--start)"
};
export default c_tabs_link_accent_start;